//hook
import { useState, useEffect } from "react"
import { useApi } from "../../hooks/useApi"
import { UserConsumer } from "../../hooks/context/UserContext"

//api
import { GetMyDriversApi } from "../../api/Host/GetMyDriversApi"
import { DeleteDriverApi } from '../../api/Host/DeleteDriverApi';

//component
import NoData from "../../component/NoData"
import AddDriver from "../../popup/AddDriver"
import DriverCard from "../../component/driverCard/DriverCard"
import DeleteConfirmation from "../../popup/DeleteConfirmation";


//image
import driverPlaceHolder from "../../assets/driverPlaceHolder.png"

//mui
import { DialogProps } from '@mui/material/Dialog';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';


//mui icon
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ReplayIcon from '@mui/icons-material/Replay';
import GroupsIcon from '@mui/icons-material/Groups';

//tranlsate
import { useTranslation } from "react-i18next";
import i18n from "../../translate/i18n"

//type
import { driverProfileType } from "../../api/completedRole/type/CompletedRoleType"



const MyDriver = () => {
  const {t} = useTranslation()
  const { 
    loading: myDriverLoading, 
    error: myDriverError, 
    HandlerApi: getMyDrivers
   } = useApi(GetMyDriversApi, "GET")
   let [myDriver, setMyDriver] = useState<driverProfileType[]>([])
   let [selectedDriver, setSelectedDriver] = useState<driverProfileType>()
  let [openDeleteConfirmation, setOpenDeleteConfirmation] = useState<boolean>(false);
  const [openAddDriver, setOpenAddDriver] = useState<{open:boolean,scrollType: DialogProps['scroll']}>({
    open:false,
    scrollType: "paper",
  });

  const {
      loading: deleteDriverLoading,
      error: deleteDriverError,
      HandlerApi: deleteDriver
  } = useApi(DeleteDriverApi, "DELETE");
   
  useEffect(() => {
  const fetchData = async () => {
    let result = await getMyDrivers();
    setMyDriver(result.data);
  }
  fetchData();
  },[])
  return (
    <div className="relative">
      <div onClick={()=> setOpenAddDriver({open: true, scrollType: "paper"})} className={`w-fit mb-3 cursor-pointer flex justify-between items-center gap-2 p-2 text-[12px] rounded-lg text-white bg-paretnerColor`}>
        <p> 
          <ControlPointIcon/>
        </p>
        <p>{t("add_driver")}</p>
      </div>
      <Card className="!bg-paretnerColor !text-white mb-5">
          <CardContent className="!flex items-center gap-5">
            <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14 }}>
              <GroupsIcon className="!text-white !text-[50px]"/>
            </Typography>
            <div>
              <Typography variant="h5" component="div">
                {t("drivers_count")}
              </Typography>
              <Typography variant="body2">
                {myDriverLoading ? 0 : myDriver?.length} - {t("drivers")}
              </Typography>
            </div>
          </CardContent>
        </Card>
      <div>
        {
          <div>
            {
              myDriverLoading
              ?
                <div className='flex justify-center'>
                  <CircularProgress/>
                </div>
              : myDriverError
                ?
                  <div className='cursor-pointer flex justify-center'>
                    <ReplayIcon onClick={()=>{getMyDrivers()}} className='!text-[40px]'/>
                  </div>
                :
                  myDriver.length === 0
                  ? <NoData title={t("drivers")} description={t("you_don't_have_any_drivers_yet")} image={driverPlaceHolder}/>
                  :
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(270px, 1fr))", gap: "20px" }}>
                    {
                      myDriver.map((element, index) => (
                        <div
                        key={index}
                        >
                          <DriverCard 
                          setOpenAddDriver={setOpenAddDriver} 
                          setSelectedDriver={setSelectedDriver} 
                          element={element} 
                          setOpenDeleteConfirmation={setOpenDeleteConfirmation}
                          />
                        </div>
                      ))
                    }
                  </div>
            }
          </div>
        }
      </div>
      {
        openAddDriver.open
        ? <AddDriver 
          selectedDriver={selectedDriver}
          setSelectedDriver={setSelectedDriver}
          openAddDriver={openAddDriver} 
          setOpenAddDriver={setOpenAddDriver} 
          setMyDriver={setMyDriver} 
          getMyDrivers={getMyDrivers}
        />
        : null
      }
      <DeleteConfirmation 
      openDeleteConfirmation={openDeleteConfirmation} 
      setOpenDeleteConfirmation={setOpenDeleteConfirmation} 
      id={selectedDriver?.id}
      deleteFunction={deleteDriver}
      deleteLoading={deleteDriverLoading}
      recallFunction={getMyDrivers}
      setData={setMyDriver}
      />
    </div>
  )
}

export default MyDriver